import { Options } from '../options.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { buildUrl } from '@wizbii-utils/angular/core';
import { Profile } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

export interface ProfileApiConfig {
  baseUrl: string;
}

export const PROFILE_API_CONFIG = new InjectionToken<ProfileApiConfig>('PROFILE_API_CONFIG');

@Injectable()
export class ProfileWebservice {
  readonly #http = inject(HttpClient);
  readonly #profileApiConfig = inject(PROFILE_API_CONFIG);

  readonly #baseUrl = this.#profileApiConfig.baseUrl;

  /**
   * get a profile
   * @param {string} id Profile id
   * @param {Object} [options] Angular Options for the request
   */
  get(id: string, options?: Options): Observable<Profile> {
    return this.#http.get<Profile>(buildUrl(`${this.#baseUrl}/api/profiles/:id`, { id }), options);
  }

  /**
   * Update a profile
   * @param {string} profileId ID of the user
   * @param {Object} profile new profile
   * @param {Object} [options] Angular Options for the request
   */
  updateProfile(profileId: string, profile: Profile, options?: Options): Observable<Profile> {
    return this.#http.patch<Profile>(`${this.#baseUrl}/api/profiles/${profileId}`, { ...profile }, options);
  }
}
